import { Component, OnDestroy, OnInit, Output } from '@angular/core';
import { Sgke032aResponseMiseisanInfo } from 'sg-api';
import { SgAriaMessage } from '../../../../../../sg-base/sg-base-shared/models/sg-aria-message';
import { ResponseMsgUtils } from '../../../../../sg-ke-shared/util/response-msg-utils';

@Component({
  selector: 'app-sgke030d',
  templateUrl: './sgke030d.component.html',
  styleUrl: './sgke030d.component.scss'
})
export class Sgke030dComponent implements OnInit, OnDestroy {
  /** メッセージエリア */
  @Output() errorMessageModelArray: Array<SgAriaMessage> = new Array<SgAriaMessage>();

  // 振替登録ラジオボタン
  registType: string = '1';

  // SGKE020Dにある検索結果リストの模擬
  searchResultList = [{
    kinkoMno: '200000000000001',
    kinkoRrkno: '3001',
    kinkoUpdateSrno: '40001',
    kinkoexUpdatesequencenumber: '50001',
    receiveMoneyNo: '60001',
    paymentContractNo: '123456789',
    remny: 15000
  }]

  /** 未精算管理番号 */
  private kinkoMno: string;
  /** 未精算金履歴番号 */
  private kinkoRrkno: string;

  /**
   * コンストラクタ
   * @param {ResponseMsgUtils} responseMsgUtils
   * @memberof Sgke030dComponent
   */
  constructor(
    public responseMsgUtils: ResponseMsgUtils
  ) { }

  /**
   * 初期処理
   * @memberof Sgke030dComponent
   */
  ngOnInit() {
  }

  /**
   * 購読解除
   * @memberof Sgke030dComponent
   */
  ngOnDestroy() {
  }

  /**
   * ラジオボタン押下時
   * @param {*} event
   * @memberof Sgke030dComponent
 */
  onChangeRadio(event: string): void {
    this.registType = event;
  }


  /**
   * 020d再描画再現
   * @memberof Sgke030dComponent
   */
  search(miseisanInfo: Sgke032aResponseMiseisanInfo = null) {

    this.kinkoMno = miseisanInfo.kinkoMno;
    this.kinkoRrkno = miseisanInfo.kinkoRrkno;

    // ラジオボタン選択解除
    this.registType = "";

  }




  /**
* 正常メッセージ出力
*
* @private
* @param {string} message
*  @memberof Sgke020dComponent
*/
  public showNormalMsg(message: string): void {

    this.errorMessageModelArray = new Array<SgAriaMessage>;
    // メッセージオブジェクトを作成
    let messageItem: SgAriaMessage = {
      message: message,
      messageClass: "mat-card-background-primary",
      icon: "done",
      iconClass: "mat-icon-color-primary"
    };

    // errorMessageModelArrayにメッセージオブジェクトを追加
    this.errorMessageModelArray.push(messageItem);
  }

  /**
   * 警告メッセージ出力
   * @public
   * @param {string} message
   * @param {Array<SgAriaMessage>} errorMessageModelArray
   * @memberof ResponseMsgUtils
   */

  public showWarningMsg(message: string): void {

    this.errorMessageModelArray = new Array<SgAriaMessage>;
    // メッセージオブジェクトを作成
    let messageItem: SgAriaMessage = {
      message: message,
      messageClass: "mat-card-background-warning",
      icon: "warning",
      iconClass: "mat-icon-color-warning"
    };

    // errorMessageModelArrayにメッセージオブジェクトを追加
    this.errorMessageModelArray.push(messageItem);
  }
  /**
   * エラーメッセージ出力
   *
   * @private
  
   * @param {string} message
   * @memberof Sgke020dComponent
   */
  public showErrorMsg(message: string): void {

    this.errorMessageModelArray = new Array<SgAriaMessage>;
    // メッセージオブジェクトを作成
    let messageItem: SgAriaMessage = {
      message: message,
      messageClass: "mat-card-background-error",
      icon: "cancel",
      iconClass: "mat-icon-color-error"
    };

    // errorMessageModelArrayにメッセージオブジェクトを追加
    this.errorMessageModelArray.push(messageItem);
  }

  /**
   * エラーメッセージ表示領域をクリア
   * @private
   * @memberof sgke020dcomponent
   */
  public clearErrorMsg() {
    if (this.errorMessageModelArray) {
      this.errorMessageModelArray.length = 0;
    }
  }
  /**
   * エラーメッセージ表示
   * @memberof Sgke020dComponent
   */
  showMsg(errors) {
    // メッセージを表示
    this.errorMessageModelArray = this.responseMsgUtils.createResponseMsg(errors, this.errorMessageModelArray);
  }
}
